module.exports = __webpack_public_path__ + "img/reload.68fca44b.png";